import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import React from 'react'

interface MoreInfoPopupProps {
  data: warehouse.WarehouseActionKeyCabinet
}

const MoreInfoPopup: React.FC<MoreInfoPopupProps> = ({ data }) => {
  const { t } = useTranslation('keyCabinet')
  return (
    <Popup>
      <div className='moreInfo__popup'>
        <div className='popup__title'>
          <div>{data.name}</div>
        </div>
        <div className='moreInfo__popup__section'>
          <div className='moreInfo__popup__label'>{t('location')}</div>
          <p>{data.placeName} {data.location}</p>
        </div>
        <div className='moreInfo__popup__section'>
          <div className='moreInfo__popup__label'>{t('howToUse')}</div>
          <p>{data.instruction}</p>
        </div>
      </div>
    </Popup>
  )
}

export default MoreInfoPopup